export var AssignmentComparisonOperator;
(function (AssignmentComparisonOperator) {
    AssignmentComparisonOperator["StartsWith"] = "startsWith";
    AssignmentComparisonOperator["EndsWith"] = "endsWith";
    AssignmentComparisonOperator["Contains"] = "contains";
    AssignmentComparisonOperator["Equals"] = "equals";
    AssignmentComparisonOperator["NotContains"] = "notContains";
})(AssignmentComparisonOperator || (AssignmentComparisonOperator = {}));
//# sourceMappingURL=assignment-comparison-operator.js.map